import React, { useState } from 'react';

import { Box, Heading } from '@chakra-ui/react';
import path from 'node:path';

import {
  Blog,
  getBlogData,
  IBlogItem,
} from '@r-client/republic-capital/feature/blog';
import { Layout } from '@r-client/republic-capital/feature/static-layout';

import { SEOMetaTags } from '../../components/seo-meta-tags/seo-meta-tags';

interface IBlogPageProps {
  items: IBlogItem[];
}

// get static props
const PARSED_FEED_LOCATION = path.join(
  process.env.NX_WORKSPACE_ROOT!,
  'apps/republic-capital',
  './feed.json'
);

export async function getStaticProps() {
  return {
    props: {
      items: await getBlogData(PARSED_FEED_LOCATION),
    },
  };
}

export function InsightsPage({ items }: IBlogPageProps) {
  const [newItems] = useState<IBlogItem[]>(items);

  return (
    <Box>
      <SEOMetaTags title="Insights" />
      <Layout padTop gutterBottom>
        <Heading
          variant="page"
          mb={4}
          textAlign={{ base: 'center', sm: 'left' }}
        >
          Insights
        </Heading>
        <Blog items={newItems} />
      </Layout>
    </Box>
  );
}

export default InsightsPage;
